import Request from "./request";

export default class PublicKeyService {
	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return (this._instance = new PublicKeyService());
	}

	list() {
		return Request.instance()
			.get(`/console/v1/public-key`)
			.then(resp => resp.data);
	}

	getById(id) {
		return Request.instance()
			.get(`/console/v1/public-key/${id}`)
			.then(resp => resp.data);
	}

	create(createRequest) {
		return Request.instance().post(`/console/v1/public-key`, createRequest);
	}

	update(id, updateRequest) {
		return Request.instance().put(
			`/console/v1/public-key/${id}`,
			updateRequest
		);
	}

	deleteById(id) {
		return Request.instance().delete(`/console/v1/public-key/${id}`);
	}
}
